import React from 'react';
import './InvoiceSummary.css';

const InvoiceSummary = () => {
  return (
    <div className="invoice-summary-container">
      <div className="invoice-card">
        <p className="upcoming-label">Upcoming payment</p>
        <h2 className="amount">$70.00</h2>
        <p className="due-date"><strong>Due on March 30 2025</strong></p>

        <div className="button-group">
          <button className="btn-pay">Pay bill</button>
          <button className="btn-invoice">Invoice</button>
        </div>
      </div>

      <div className="previous-balance">
        <span role="img" aria-label="thumbs up">👍</span>
        &nbsp; Previous Balance:
        <strong> $15.83</strong>&nbsp;
        Paid on March 15 2025
        <span role="img" aria-label="copy" className="copy-icon">📋</span>
      </div>
    </div>
  );
};

export default InvoiceSummary;
